import config from '@plone/volto/registry';

import type { QubicaContentProps } from '../../Common/utils';
import styles from '../styles.module.css';

const BlogBanner = (content: QubicaContentProps) => {
  const Image = config.getComponent('Image').component;

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.imageContainer}>
        <div className={styles.showOverlay} />
        {content.image ? (
          <Image
            alt={content.image_caption ?? ''}
            item={content}
            className={styles.image}
          />
        ) : (
          <div className={styles.imgPlaceholder} />
        )}
      </div>
      <div className={styles.payoffText}>
        <div className={styles.payoffTitleContainer}>
          <div className={styles.payoffTitle}>{content.title}</div>
        </div>

        {content.description && (
          <div className={styles.payoffDescription}>{content.description}</div>
        )}
      </div>
    </div>
  );
};

export default BlogBanner;
